export const DATEPICKER_TOOLTIP =
  'You can query before and after the selected day by clicking on the same day consecutively.'
